/**
 * Normalizes objects from api request.
 * Takes a list of objects and returns a new object as { keyName : object }.
 * @param {Array} response list of objects
 * @param {String} keyName optional key name. Defaults to 'id'
 */
export const responseNormalizer = (response, keyName = "id") =>
  response.reduce((obj, item) => ({ ...obj, [item[keyName]]: item }), {});
